import { RowItemType, Section, UIElementType } from '../../models';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { EdgeRlInfoFieldIds, EdgeRlSectionIds } from './base-config-models';
import { MonitorSeriesNames } from '../../../location-card.constants';
import { openSiltDialog } from '../../actions';
import { field } from '../../core/field-schema';
import { pattern } from '../../core/validator-builders';
import { EdgeRlLocationCardState } from './models';

export const edgeRlInfo = (state: EdgeRlLocationCardState): Section => {
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;
    const settings = state.settings;
    const config = state.monitorConfiguration;

    const isSwitchMonitor = details && details.series !== MonitorSeriesNames.edgeRl;
    const isEditMode = !!details;

    const disableFieldClass = !state.permissions.isMonitorEditor ? 'edge-rl-section disable-field' : 'edge-rl-section';

    return {
        info: {
            id: EdgeRlSectionIds.EdgeRlInfo,
            title: 'ADD_EDIT.EDGE_RL',
            displayTitle: true,
            expandable: true,
            expanded: false,
            panelClass: disableFieldClass,
        },
        rows: [
            {
                info: {
                    id: 'silt-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    {
                        id: 'silt-container',
                        type: RowItemType.Section,
                        section: {
                            info: {
                                id: 'silt-wrapper',
                                displayTitle: false,
                                title: '',
                                expandable: false,
                                panelClass: 'custom-flat-button custom-width slide-active-display',
                            },
                            rows: [
                                {
                                    info: {
                                        id: 'silt-input-row',
                                        panelClass: 'flex',
                                    },
                                    items: [
                                        field.number(EdgeRlInfoFieldIds.Silt, 'silt', {
                                            panelClass: 'full-width',
                                            placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_SILT',
                                            placeholderSuffix: settings.depthUnit,
                                            value: isEditMode && !isSwitchMonitor && config?.silt != null ? Number(config.silt.toFixed(2)) : 0,
                                            readonly: true,
                                            validators: [
                                                pattern({
                                                    value: settings.isMetric
                                                        ? REGEX_CONFIG.installationMetricValuePattern
                                                        : REGEX_CONFIG.installationValuePattern,
                                                }),
                                            ],
                                        }),
                                        {
                                            id: EdgeRlInfoFieldIds.SiltEditButton,
                                            type: RowItemType.UI,
                                            uiType: UIElementType.Button,
                                            visible: state.permissions.isBasicDataEditingAllowed,
                                            iconName: 'edit',
                                            tooltip: 'COMMON.SILT_EDITOR',
                                            disabled: !isEditMode,
                                            panelClass: 'no-margin',
                                            events: {
                                                onClick: () => [
                                                    openSiltDialog({ updateFieldId: EdgeRlInfoFieldIds.Silt, mpIndex: 0 }),
                                                ],
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    };
};
